import '@fancyapps/fancybox';

(function ($) {
  'use strict';

  $(document).ready(function () {
    // Video popup using fancybox
    $('.section-hchv-desc .play-icon').on('click', function () {
      const videoType = $(this).data('video-type');
      const videoUrl = $(this).data('video-url');

      const type = videoType === 'upload' ? 'video' : 'iframe';

      $.fancybox.open({
        src: videoUrl,
        type: type,
        iframe: {
          preload: false,
        },
      });
    });


    // accomodation video 
    $('.section-media .play-icon').on('click', function () {
      const videoUrl = $(this).data('video-url');
      $.fancybox.open({
        src: videoUrl,
        type: 'video',
      });
    });
  });
})(jQuery);
